export const SOCKET_ONOPEN = 'SOCKET_ONOPEN';
export const SOCKET_ONCLOSE = 'SOCKET_ONCLOSE';
export const SOCKET_ONMESSAGE = 'SOCKET_ONMESSAGE';
export const SOCKET_NEWMESSAGE = 'SOCKET_NEWMESSAGE';
export const SOCKET_ONERROR = 'SOCKET_ONERROR';
export const SET_SOCKET = 'SET_SOCKET';
export const SET_CREDENTIALS = 'SET_CREDENTIALS';
export const SET_RECONNECTION = 'SET_RECONNECTION';
export const SET_RECONNECTION_TIMEOUT = 'SET_RECONNECTION_TIMEOUT';
export const SUSPEND_MESSAGE_UPDATE = 'SUSPEND_MESSAGE_UPDATE';

export default {
  SOCKET_ONOPEN,
  SOCKET_ONCLOSE,
  SOCKET_ONMESSAGE,
  SOCKET_NEWMESSAGE,
  SOCKET_ONERROR,
  SET_SOCKET,
  SET_CREDENTIALS,
  SET_RECONNECTION,
  SET_RECONNECTION_TIMEOUT,
  SUSPEND_MESSAGE_UPDATE,
};
